import { useState } from "react";
import { useDispatch } from "react-redux";
import uniqid from "uniqid";

import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { validateEmail } from "../../../utils/validations";
import { handleApiErrors } from "../../../utils/handleErrors";
import { SignIn } from "../../../store/reducers/auth.reducer";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";

import Notify from "../../../components/notification/notify";

import "./styles.css";

export function SignUpIFrame() {
  const [readTerms, setReadTerms] = useState(false);
  const { ApiSignUp } = useApi();

  const dispatch = useDispatch();
  const [form, setForm] = useState({ nickname: uniqid() });

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function SignUpSubmit(e) {
    e.preventDefault();

    if (!form.name) return Notify({ type: "danger", message: t("Errors.EmptyName") });
    if (!form.password) return Notify({ type: "danger", message: t("Errors.EmptyPassword") });
    if (!form.passwordConfirmation) return Notify({ type: "danger", message: t("Errors.EmptyPasswordConfirmation") });
    if (form.password !== form.passwordConfirmation)
      return Notify({ type: "danger", message: t("Errors.InvalidPasswordConfirmation") });
    if (!form.email) return Notify({ type: "danger", message: t("Errors.EmptyEmail") });
    if (!validateEmail(form.email)) return Notify({ type: "danger", message: t("Errors.InvalidEmail") });
    if (!readTerms) return Notify({ type: "danger", message: t("Errors.NotReadTerms") });

    const { data } = await ApiSignUp(form);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(SignIn(data));

    window.parent.postMessage({ action: "signup" }, "*");
  }

  async function SubmitFacebook({ userID, name, email, picture, accessToken }) {
    if (!userID) return;

    const params = {
      nickname: form.nickname,
      facebook_id: userID,
      name,
      email,
      avatar: picture?.data?.is_silhouette ? undefined : picture?.data?.url,
      password: accessToken,
    };

    const { data } = await ApiSignUp(params);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(SignIn(data));

    window.parent.postMessage({ action: "signup" }, "*");
  }

  async function SubmitGoogle({ accessToken, googleId, profileObj: { name, email, imageUrl } }) {
    if (!googleId) return;

    const params = {
      nickname: form.nickname,
      google_id: googleId,
      name,
      email,
      avatar: imageUrl,
      password: accessToken,
    };

    const { data } = await ApiSignUp(params);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    dispatch(SignIn(data));

    window.parent.postMessage({ action: "signup" }, "*");
  }

  return (
    <div class="signup-modal-content">
      <div class="signup-modal-header">
        <div class="menu-tabs">
          <div class="register-user">
            <h3>
              <img src="/images/registertick.png" alt="" />
              {t("SignUp.SignUp")}
            </h3>
          </div>
        </div>
      </div>
      <div class="signup-modal-body">
        <div class="register-sec">
          <div class="login-fields">
            <form onSubmit={SignUpSubmit} class="lgn-frm">
              <input
                type="text"
                placeholder={t("SignUp.Form.User")}
                name="name"
                value={form.name || ""}
                onChange={handleInputChange}
              />
              <input
                placeholder={t("SignUp.Form.Password")}
                type="password"
                name="password"
                value={form.password || ""}
                onChange={handleInputChange}
              />
              <input
                placeholder={t("SignUp.Form.PasswordConfirmation")}
                type="password"
                name="passwordConfirmation"
                value={form.passwordConfirmation || ""}
                onChange={handleInputChange}
              />
              <input
                type="text"
                placeholder={t("SignUp.Form.Email")}
                name="email"
                value={form.email || ""}
                onChange={handleInputChange}
              />

              <div className="input-box input-check">
                <input type="checkbox" id="terms" checked={readTerms} onClick={() => setReadTerms(!readTerms)} />
                <label
                  for="terms"
                  dangerouslySetInnerHTML={{
                    __html: t("SignUp.AcceptTerms", { link: t("Config.TermsLink") }),
                  }}
                />
              </div>

              <div class="login-btns">
                <div class="register-btn">
                  <button type="submit">
                    <span>{t("SignUp.Form.Submit")}</span>
                    <small>
                      <img src="/images/popup-regicon.png" alt="" />
                    </small>
                  </button>
                </div>
              </div>

              <div className="social-login">
                <p>{t("SignUp.RegisterWith")}</p>
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                  fields="name,email,picture"
                  callback={SubmitFacebook}
                  render={(renderProps) => (
                    <button type="button" onClick={renderProps.onClick}>
                      <img src="/images/facebook-m.png" alt="" />
                    </button>
                  )}
                />

                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_APP_ID}
                  render={(renderProps) => (
                    <button type="button" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                      <img src="/images/google-m.png" alt="" />
                    </button>
                  )}
                  buttonText="Login"
                  onSuccess={SubmitGoogle}
                  onFailure={(e) => console.log(e)}
                  cookiePolicy={"single_host_origin"}
                />
              </div>
            </form>
          </div>
          <div class="login-imgrht-layer">
            <img src="/images/bglayer.png" alt="" />
          </div>
          <div class="login-imgrht-up">
            <img src="/images/registerbg.png" alt="" />
          </div>
          <div class="login-imgrht">
            <img src="/images/registerbg1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpIFrame;
